var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPfWordmarkWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680.75 98.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.58,0a23.28,23.28,0,0,1,.18,46.54c-1.07,0-13.22.09-36,.09v16H0V0Zm.27,34.31A11,11,0,0,0,60.93,23.23c0-6.17-4.83-10.54-11.08-11H13.76V34.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.25,47.26H95.07L87.12,62.63H71.48L104.36,0h17.69l32.78,62.63H139.29Zm-18-34.49L101.5,35h23.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.17,62.63H225.33L182,18.67V62.54H168.25V0l15.54.09L226.5,44V0h13.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.94,0V12.24h-29.3V62.63H282.88V12.24h-29.3V0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.72,62.63H398.05V37.43H353.11v25.2H339.35V0h13.76V25.19h44.94V0h13.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.49,12.33h-58.6v13H480.7V37.52H438.89V50.39h58.6V62.63H425.13V0h72.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.94,62.63H540.39c-16-.27-29.49-14.75-29.49-31.36C510.9,15,523.59,1.16,539.22,0H567.1c15.63,1.16,28.32,15,28.32,31.27C595.42,47.88,581.93,62.36,565.94,62.63Zm-2.15-13a18.32,18.32,0,0,0,18.67-18.4c0-9.92-7.5-17.78-17.77-18.23H541.64a18.32,18.32,0,0,0,.89,36.63Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M680.75,62.63H665.92l-43.33-44V62.54H608.83V0l15.55.09L667.08,44V0h13.67Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.52,82.81v5.1H4.58V98.37H0V72.27H24.11v5.14H4.58v5.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.37,72.27H91v26.1H86.37Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.17,98.37h-4.94L157.79,80.05V98.33h-4.58V72.27l5.18,0,14.23,18.28V72.27h4.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.15,92h-12l-2.65,6.41h-5.21l10.95-26.1h5.9L266,98.37h-5.18Zm-6-14.37-3.9,9.27H256Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.05,98.37h-4.94L331.67,80.05V98.33h-4.59V72.27l5.18,0,14.23,18.28V72.27h4.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.59,77.41c-3.21.18-5.92,3.72-5.92,7.89,0,4.36,2.8,8,6.22,8h13.34v5.1H421.94c-5.33-.11-9.82-6.14-9.82-13.07,0-6.74,4.22-12.58,9.43-13l14.68,0v5.14Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.49,72.27h4.58v26.1h-4.58Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.24,92H573.18l-2.65,6.41h-5.21l11-26.1h5.89l10.93,26.1h-5.18Zm-6-14.37-3.9,9.27h7.77Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.17,72.31h4.58v21h17.54v5.1H654.17Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfWordmarkWhite);
export default __webpack_public_path__ + "static/media/pf_wordmark_white.09d1d79b02f7e3a73457d9ae187ed780.svg";
export { ForwardRef as ReactComponent };